module.exports = __webpack_public_path__ + "static/img/10.4b18b6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/10.png
// module id = Dt0/
// module chunks = 0